import { FC } from 'react'

import { ListGroupItem, LoadingSpinner, ZeroState } from '@/components'
import { DocumentListItem } from '@/compositions'
import { ConnectedYearNavigator } from '@/connectors'
import { YearEndStatement } from '@/entities/YearEndStatement/YearEndStatement'
import { trans } from '@/helpers/trans'
import { UserDocumentViewModel } from '@/models'

import './Documents.scss'

interface DocumentsProps {
    isLoading: boolean
    documents: UserDocumentViewModel[]
    selectedYearEndStatement?: YearEndStatement
    onDownloadYearEndStatementClick: (year: number) => void
    onChangeYear: (year: number) => void
}

export const Documents: FC<DocumentsProps> = ({
    isLoading,
    documents = [],
    selectedYearEndStatement,
    onDownloadYearEndStatementClick,
    onChangeYear,
}) => (
    <>
        <ConnectedYearNavigator onChangeYear={onChangeYear} />
        {isLoading && <LoadingSpinner />}
        {documents.length === 0 && ! selectedYearEndStatement && <ZeroState text={trans('pages.documents.noDocumentsFound')} />}
        {selectedYearEndStatement && (
            <ul>
                <ListGroupItem
                    key={selectedYearEndStatement.employment.id}
                    onClick={() => onDownloadYearEndStatementClick(selectedYearEndStatement.year)}
                    className="documents__list-item"
                >
                    <button type="button" className="document-list-item list-group-item__header text w-100">
                        <div className="d-flex">
                            <div className="font-weight-bold">{trans('common.yearEndStatement', { year: selectedYearEndStatement.year })}</div>
                        </div>
                    </button>
                </ListGroupItem>
            </ul>
        )}
        {documents.length > 0 && (
            <ul>
                {documents.map(document => (
                    <DocumentListItem
                        key={document.id}
                        document={document}
                        className="documents__list-item"
                    />
                ))}
            </ul>
        )}
    </>
)
